const typeBase = '[FlashSpread]';

export class GetFlashSpreadData {
  static readonly type = `${typeBase} GetFlashSpreadData`;
  constructor(
    public borrowerId: number,
  ) {}
}

export class FlashSpreadPusherSubscribe {
  static readonly type = `${typeBase} FlashSpreadPusherSubscribe`;
  constructor(
    public borrowerId: number,
  ) {}
}

export class ClearFlashSpreadState {
  static readonly type = `${typeBase} ClearFlashSpreadState`;
  constructor(
    public borrowerId: number,
  ) {}
}
